<template>
  <div id="BMCampaigns">
    <v-container grid-list-md fluid class="pt-0">
      <v-card-title>
        <!-- <v-select v-model="searchByCampaignStatus" label="Search by campaign status" :items="statusList" class="pr-2" @change="filterByStatus"></v-select> -->
        <v-select v-model="searchByAdStatus" label="Search by ad status" :items="statusList" class="pr-2" @change="filterByStatus"></v-select>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <!-- <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          ></v-text-field> -->
      </v-card-title>
      <v-card class="mt-1">
        <v-data-table
          :headers="headers"
          :items="googleAdList"
          class="pf-data-table" 
          :pagination.sync="pagination"
          no-data-text="No pending requests"
          >
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.budget }}</td>
            <td>{{ formatDate(props.item.start_date, 'MM/DD/YYYY') }}</td>
            <td>{{ props.item.period }}</td>
            <td>{{ groupCampaign.status }}</td>
            <td>{{ props.item.status }}</td>
            <td>{{ props.item.payment.status }}</td>
            <!-- <td>{{ props.item.payment.paid_amount }}</td> -->
            <td align="right">
              <v-btn icon class="ma-0" @click="publishCampaign(props.item)" title="Publish" :disabled="props.item.status !== 'PENDING'">
                <v-icon size="22" color="grey darken-2">campaign</v-icon>
              </v-btn>
              <v-btn icon class="ma-0" @click="deleteItem(props.item)" disabled>
                <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <!-- <app-modal :active="showAddImagePopup" v-if="showAddImagePopup" width="70%">
      <div slot="modal-content">
        <v-card>
          <v-toolbar card dark class="pf-bg-teal">
            <v-btn class="pf-modal-close" icon dark @click="resetSelections">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Ad additional info</v-toolbar-title>
          </v-toolbar>
          <v-card-text class="mt-4 mb-4">
            <v-form ref="adInfoForm">
              <v-layout wrap>
                <v-flex sm6>
                  <v-text-field v-model.number="currentAdTexts.headline" :rules="rules.headline" label="Ad headline" class="required pr-4 pl-4"></v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-text-field v-model.number="currentAdTexts.long_headline" :rules="rules.long_headline" label="Ad long headline" class="required pr-4 pl-4"></v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-text-field v-model.number="currentAdTexts.description" :rules="rules.description" label="Ad description" class="required pr-4 pl-4"></v-text-field>
                </v-flex>
                <v-flex sm6>
                  <v-text-field v-model.number="currentAdTexts.business_name" :rules="rules.business_name" label="Ad business name" class="required pr-4 pl-4"></v-text-field>
                </v-flex>
                <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                  <upload-btn @file-update="fileSelected($event, 'landscape')" title="Ad landscape image" noTitleUpdate>
                    <template slot="icon-left">
                      <v-icon size="16" class="pr-1">upload</v-icon>
                    </template>
                  </upload-btn>
                  <v-icon size="35" :color="!!currentAssets.landscape ? 'green' : 'red'">{{ !!currentAssets.landscape ? 'check_circle' : 'cancel' }}</v-icon>
                </v-flex>
                <v-flex sm6 class="mt-4 flex-start pr-4 pl-4">
                  <upload-btn @file-update="fileSelected($event, 'square')" title="Ad square image" noTitleUpdate>
                    <template slot="icon-left">
                      <v-icon size="16" class="pr-1">upload</v-icon>
                    </template>
                  </upload-btn>
                  <v-icon size="35" :color="!!currentAssets.square ? 'green' : 'red'">{{ !!currentAssets.square ? 'check_circle' : 'cancel' }}</v-icon>
                </v-flex>
                <v-flex sm6 class="mt-4 flex-column pr-4 pl-4">
                  <h4 class="mb-2">Image resolutions</h4>
                  <span><b>Landscape: </b>{{ assetResolution.landscape.width }} x {{ assetResolution.landscape.height }}</span>
                  <span><b>Square: </b>{{ assetResolution.square.width }} x {{ assetResolution.square.height }}</span>
                  <small>Please upload images with mentioned resolution</small>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
              <v-btn
                class="pf-btn-text-white pf-bg-green"
                @click="publishCampaign"
                :disabled="!!!currentAssets.landscape || !!!currentAssets.square"
              >
                Publish Campaign
              </v-btn>
            <v-btn
              class="pf-btn-text-white pf-bg-pink"
              @click="resetSelections"
              >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </app-modal> -->
  </div>
</template>
<script>
/* global session store config */
/* eslint-disable indent */
import AppModal from '../../components/AppModal';
import { getCollection, uploadFile, request, formatDate, getOne } from '../../helpers/helpers';

import UploadButton from 'vuetify-upload-button';
import swal from 'sweetalert2';

import { mapGetters } from 'vuex';

export default {
  name: 'BMCampaigns',
  components: {
    'app-modal': AppModal,
    'upload-btn': UploadButton
  },
  data: () => ({
    headers: [
      { text: 'Name', value: 'name', align: 'left' },
      { text: 'Budget', value: 'budget', align: 'left' },
      { text: 'Start Date', value: 'start_date', align: 'left' },
      { text: 'Period', value: 'period', align: 'left' },
      { text: 'Campaign Status', value: 'campaign.status', align: 'left' },
      { text: 'Ad Status', value: 'status', align: 'left' },
      { text: 'Payment', value: 'payment.status', align: 'left' },
      // { text: 'Amount Paid', value: 'payment.paid_amount', align: 'left' },
      { text: '', sortable: false }
    ],
    // search: '',
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    adType: 'RESPONSIVE_SEARCH_AD',
    showAddImagePopup: false,
    currentGoogleAd: null,
    currentAssets: {
      landscape: null,
      square: null
    },
    groupCampaignAssets: {
      landscape: null,
      square: null
    },
    currentAdTexts: {
      headline: '',
      description: '',
      long_headline: '',
      business_name: 'ParentFinder BM Campaign',
    },
    rules: {
      headline: [v => !!v || 'Ad headline is required'],
      long_headline: [v => !!v || 'Ad long headline is required'],
      description: [v => !!v || 'Ad description is required'],
      business_name: [v => !!v || 'Ad business name is required'],
    },
    assetResolution: {
      landscape: {
        width: 960,
        height: 502
      },
      square: {
        width: 626,
        height: 626
      }
    },
    // searchByCampaignStatus: 'ALL',
    searchByAdStatus: 'PENDING',
    statusList: ['ALL', 'PENDING', 'ENABLED', 'PAUSED', 'REMOVED'],
    googleAdList: [],
    groupCampaign: null
  }),
  computed: {
    ...mapGetters(['Agency']),
    GoogleAd: {
      get () {
        return store.state.GoogleAd;
      },
      set (val) {
        store.commit('setGoogleAd', val);
      }
    }
  },
  watch: {
    GoogleAd (val) {
      this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    }
  },
  async created () {
    await this.getGroupCampaign();
    await this.getGroupCampaignAssets();
    await this.fetchGoogleAds();
    this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    this.filterByStatus();
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  methods: {
    formatDate (date, format) {
      return formatDate(date, format);
    },
    filterByStatus () {
      this.googleAdList = this.GoogleAd.filter(x => (this.searchByAdStatus === 'ALL' || x.status === this.searchByAdStatus));
      // && (this.searchByCampaignStatus === 'ALL' || x.campaign.status === this.searchByCampaignStatus)
    },
    async getGroupCampaign () {
      if (!this.groupCampaign && this.Agency.google_campaign) {
        let populate = { path: 'ads' };
        let { error, data } = await getOne('Campaign', this.Agency.google_campaign, populate);
        if (error) {
            console.log(error);
        } else if (data) {
            this.groupCampaign = data;
        }
      }
    },
    async getGroupCampaignAssets () {

      /* Fetch the ad assets */
      let where = { agency: this.Agency.id, google_ad: this.groupCampaign.ads[0].id };
      let { error, data } = await getCollection('GoogleAdAsset', true, 0, '', where);
      if (error) {
        console.log(error);
      } else if (data && data.length) {
        /* Check if the asset is landscape or square */
        for (let i = 0; i < data.length; i++) {
          this.groupCampaignAssets[data[i].image_type] = data[i].resource;
        }
      }
    },
    async fetchGoogleAds () {
      if (this.Agency.google_campaign) {
        let sort = { createdAt: -1 };
        let populate = [{ path: 'campaign' }, { path: 'payment' }];
        let where = { /* status: { $in: ['PENDING'] }, */ mode: 'Group', campaign: this.Agency.google_campaign };
        let { error, data } = await getCollection('GoogleAd', true, 0, populate, where, null, null, sort);
        if (error) {
            console.log(error);
        } else if (data.length > 0) {
            this.GoogleAd = data;
            this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
            this.filterByStatus();
        }
      }
    },
    deleteItem (item) {

      swal.fire({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
          /* if (result.value) {
          (async () => {
              let { error, data, status } = await remove('Country', item.id);
              if (error) {
              console.log('error', error);
              } else {
              const index = this.Country.indexOf(item);
              this.Country.splice(index, 1);
              swal.fire(
                  'Deleted!',
                  'The Country "' + item.name + '" has been deleted.',
                  'success'
              );
              }
          })();
          } */
      });
    },
    async publishCampaign (item) {

      swal.fire({
          title: 'Are you sure?',
          text: 'Are you sure you want to approve the request?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes, approve!'
        }).then(result => {
          if (result.value) {
            (async () => {
                let error = null;
                let index = this.GoogleAd.findIndex(x => x.id === item.id);
                let campaignData = null;
                let adData = null;

                /* Approve the campaign join request by family */
                let { error: couchbaseError, data: couchbaseData } = await request(`GoogleAd/Approve/${item.id}`, 'POST');
                if (couchbaseError) {
                  console.log(couchbaseError);
                  error = couchbaseError;
                  swal.fire({
                    type: 'warning',
                    title: 'Error',
                    text: `${couchbaseError}, please try again`,
                    showConfirmButton: true,
                    onClose: () => {
                      // 
                    }
                  });
                  return;
                } else {
                  /* Update the state */
                  this.GoogleAd[index].status = 'ENABLED';
                  this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));

                  /* Publish the Group campaign if not done before */
                  if (!this.groupCampaign.resource) {

                    let returnData = await this.publishGroupCampaign();
                    
                    campaignData = returnData.campaignData || null;
                    adData = returnData.adData || null;

                    if (returnData.error) {
                      swal.fire({
                        type: 'warning',
                        title: 'Error',
                        text: `${returnData.error}, please try again`,
                        showConfirmButton: true,
                        onClose: () => {
                          return;
                        }
                      });
                      return;
                    } else {
                      if (campaignData) {
                        this.groupCampaign.resource = campaignData.resource;
                        this.groupCampaign.status = campaignData.status;
  
                        this.GoogleAd[index].campaign.status = campaignData.status;
                      }
                      if (adData) {
                        this.groupCampaign.ads[0].resource = adData.resource;
                        this.groupCampaign.ads[0].status = adData.status;
                      }                      
                    }

                  } else {
                    campaignData = this.groupCampaign;
                    adData = this.groupCampaign.ads[0];
                  }
                }
          
                if (error) {
                  console.log(error);
                  swal.fire({
                    type: 'warning',
                    title: error.message,
                    text: `${error.details ? error.details[0].errors[0].message : error.message}, please try again`,
                    showConfirmButton: true,
                    onClose: () => {
                      this.resetSelections();
                    }
                  });
                } else {
                  if (!campaignData || !adData) {
                    swal.fire({
                      type: 'warning',
                      title: 'Error',
                      text: `Something went wrong, please try again`,
                      showConfirmButton: true,
                      onClose: () => {
                        // 
                      }
                    });
                  } else {
                    swal.fire({
                      type: 'success',
                      title: 'Approved',
                      text: 'The campaign join request was approved',
                      showConfirmButton: false,
                      timer: 2500,
                      onClose: () => {
                        this.filterByStatus();
                      }
                    });
                  }
                }
            })();
          }
        });

    },
    async publishGroupCampaign () {

      let returnData = {};
      if (this.groupCampaign) {

        let campaignPayload = {
          campaign: this.groupCampaign.id,
          type: this.adType === 'RESPONSIVE_DISPLAY_AD' ? 'DISPLAY' : 'SEARCH'
        };
        let { error: campaignError, data } = await request('Campaign/Create', 'POST', campaignPayload);
        if (campaignError) {
          returnData.error = campaignError.details[0].errors[0].message;
        } else {
          returnData.campaignData = data;
        }
  
        /* Create the Ad */
        let adPayload = {
          google_ad: this.groupCampaign.ads[0].id,
          assets: this.groupCampaignAssets,
          additional_info: this.groupCampaign.ads[0].texts,
          ad_type: this.adType
        };
        let { error: adError, data: ad } = await request('GoogleAd/Create', 'POST', adPayload);
        if (adError) {
          returnData.error = adError.details[0].errors[0].message;
        } else {
          returnData.adData = ad;
        }
      }
      return returnData;
    },
    resetSelections () {
      this.showAddImagePopup = false;
      this.currentGoogleAd = null;
      this.currentAssets = {
        landscape: null,
        square: null
      };
      this.currentAdTexts = {
        headline: '',
        description: '',
        long_headline: '',
        business_name: 'ParentFinder BM Campaign',
      };
      /* Reset the list */
      this.googleAdList = JSON.parse(JSON.stringify(this.GoogleAd));
    },
    // async fileSelected (file, type) {
    //   let self = this;
    //   if (file !== 'undefined') {
    //     if (file.name.lastIndexOf('.') <= 0) {
    //       return;
    //     }
    //     window.getApp.$emit('AppProgress', true);
    //     const fr = new FileReader();
    //     fr.readAsDataURL(file);
    //     fr.addEventListener('load', async (image) => {
    //       let img = new Image();
    //       img.src = image.target.result;
    //       img.addEventListener('load', async (fileLoad) => {
    //         if (fileLoad.path[0].width !== self.assetResolution[type].width || fileLoad.path[0].height !== self.assetResolution[type].height) {
    //           swal.fire({
    //             type: 'warning',
    //             title: 'Invalid Resolution',
    //             text: `The ${type} image should have a exact resolution of ${self.assetResolution[type].width} x ${self.assetResolution[type].height}`,
    //             showConfirmButton: true,
    //             onClose: () => {
    //               window.getApp.$emit('AppProgress', false);
    //               return;
    //             }
    //           });
    //           return;
    //         } else {
    //           let postUrl = 'GoogleAdAsset/UploadAsset';
    //           let extraParams = {
    //             account: this.currentGoogleAd.account,
    //             google_ad: this.currentGoogleAd.id,
    //             image_type: type
    //           };
    //           let response = await uploadFile(postUrl, file, 'POST', extraParams);
    //           if (!response.$data) {
    //             window.getApp.$emit('AppProgress', false);
    //             console.log('error', response.$error);
    //             this.snackbar = {
    //               show: true,
    //               color: 'red',
    //               text: response.$error
    //             };
    //           } else {
    //             if (!response.$data) {
    //               if (response.error && response.error.details) {
    //                 swal.fire({
    //                   type: 'warning',
    //                   title: response.error.message,
    //                   text: `${response.error.details[0].errors[0].message}, please try again`,
    //                   showConfirmButton: true,
    //                   onClose: () => {
    //                     // 
    //                   }
    //                 });
    //               } else {
    //                 this.snackbar = {
    //                   show: true,
    //                   color: 'red',
    //                   text: 'Something went wrong, please try again'
    //                 };
    //                 window.getApp.$emit('AppProgress', false);
    //                 return;
    //               }
    //             }
    //             this.currentAssets[type] = response.$data.resource;
    //             swal.fire({
    //               type: 'success',
    //               title: 'Image uploaded successfully',
    //               showConfirmButton: false,
    //               timer: 2500,
    //               onClose: () => {
    //                 window.getApp.$emit('AppProgress', false);
    //               }
    //             });
    //           }
    //         }
    //       });
    //     });
    //   }
    // },
  }
};
</script>
<style scoped>
.upload-btn {
  padding: 0 !important;
  margin-left: -10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Campaign/group_requests.vue